export default __webpack_public_path__ + "static/media/asr_IMG1750.f58bc12e.jpg";